/**
 * 用户API
 * 用户API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The UserForm model module.
   * @module user/model/UserForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>UserForm</code>.
   * @alias module:user/model/UserForm
   * @class
   * @param name {String} 姓名
   * @param roomId {Integer} 寝室id
   */
  var exports = function(name, roomId) {
    var _this = this;

    _this['name'] = name;
    _this['roomId'] = roomId;
  };

  /**
   * Constructs a <code>UserForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:user/model/UserForm} obj Optional instance to populate.
   * @return {module:user/model/UserForm} The populated <code>UserForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 寝室id
   * @member {Integer} roomId
   */
  exports.prototype['roomId'] = undefined;



  export default exports;
;


